'use strict';

const state = { show: false, type: '', msg: '' }

const actions = {
  nShowMessage(context, payload) {
    context.commit('setNotificationOff', {})
    setTimeout(() => {
      payload.show = true
      context.commit('setNotificationOn', payload)
    }, 100);
  },
  nCloseMessage(context, payload) {
    payload = state
    context.commit('setNotificationOff', payload)
  }
}

const mutations = {
  setNotificationOn(state, payload) {
    state.notification = payload
  },
  setNotificationOff(state, payload) {
    state.notification = payload
  }
}

const getters = {
  getNotification: (state) => {
    return state.notification
  }
}

export default { getters, actions, mutations, state }